import React, { lazy, Suspense, useEffect } from 'react';
import PlThemeProvider from '@bit/twentyscoops.20scoops.paylo.styles';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import './sentry/setup';

import GlobalStyled from './GlobalStyled';
import Router from './Router';
import ScrollToTop from './components/ScrollToTop';
import RemoveFocusWhenNotTab from './components/RemoveFocusWhenNotTab';
import { SnackbarProvider } from 'components/Alert';
import LanguageHtmlUpdater from './components/LanguageHtmlUpdater';
import { Helmet } from 'react-helmet';
import { createWeb3ReactRoot, Web3ReactProvider } from '@web3-react/core';
import getLibrary, { NetworkContextName } from 'utils/getLibrary';
import { isProductionMode } from 'utils/environment';

const Web3ProviderNetwork = createWeb3ReactRoot(NetworkContextName);

const FullPageErrorFallback = lazy(() => import('components/FullPageErrorFallback'));

const FullPageErrorFallbackWithSuspense = (props) => {
  return (
    <Suspense fallback={<div />}>
      <FullPageErrorFallback {...props} />
    </Suspense>
  );
};

const App = () => {
  useEffect(() => {
    localStorage?.removeItem('i18nextLng');
  }, []);

  return (
    <>
      <Web3ReactProvider getLibrary={getLibrary}>
        <Web3ProviderNetwork getLibrary={getLibrary}>
          <BrowserRouter>
            <PlThemeProvider>
              <ScrollToTop>
                <SnackbarProvider>
                  <ErrorBoundary FallbackComponent={FullPageErrorFallbackWithSuspense}>
                    <Router />
                  </ErrorBoundary>
                  <GlobalStyled />
                  <RemoveFocusWhenNotTab />
                  <LanguageHtmlUpdater />
                </SnackbarProvider>
              </ScrollToTop>
            </PlThemeProvider>
          </BrowserRouter>
        </Web3ProviderNetwork>
      </Web3ReactProvider>
      {isProductionMode() ? (
        <Helmet>
          <script async src="https://www.googletagmanager.com/gtag/js?id=G-3C1HDQ986K" />
          <script>
            {`
             window.dataLayer = window.dataLayer || [];
             function gtag() {
               dataLayer.push(arguments);
             }
             gtag('js', new Date());
             gtag('config', 'G-3C1HDQ986K');
          `}
          </script>
        </Helmet>
      ) : null}
    </>
  );
};

export default App;
